import styled from '@emotion/styled';
import { Autocomplete, Checkbox, InputLabel, ListItemText, TextField } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { FilterChildNameSharedStyle, FilterChildSharedStyle, MenuItemStyle, TableContainerStyle } from '../Filter.mock';
import { CheckboxEntityTypeObj, GroupsMultiSelectInterfaceProps } from '../Filter.interface';

const TableContainer = styled.div(TableContainerStyle, FilterChildSharedStyle);

const ModifiedAutocomplete = ({ groupName, checkedEntity, onChangeHandler, totalEntities, placeholder }: GroupsMultiSelectInterfaceProps) => {
  const [checkedValues, setCheckedValues] = useState<CheckboxEntityTypeObj[]>([]);

  const onSelectHandler = (event: React.SyntheticEvent, value: CheckboxEntityTypeObj[]) => {
    event?.preventDefault();
    onChangeHandler(value);
  };

  const options = useMemo(() => totalEntities.map((i) => i).filter((item) => !!item) as CheckboxEntityTypeObj[], [totalEntities]);

  useEffect(() => {
    setCheckedValues(checkedEntity);
  }, [checkedEntity]);

  return (
    <TableContainer>
      <InputLabel sx={FilterChildNameSharedStyle}>
        <b>{groupName}</b>
      </InputLabel>
      <Autocomplete
        getOptionLabel={(option) => option?.display || ''}
        isOptionEqualToValue={(a: CheckboxEntityTypeObj, b: CheckboxEntityTypeObj) => a.code === b.code}
        multiple
        disableListWrap
        disableCloseOnSelect
        size="small"
        value={checkedValues}
        limitTags={2}
        renderInput={(params) => <TextField {...params} placeholder={checkedValues.length ? '' : placeholder} />}
        options={options}
        renderOption={(props, option) => (
          <li {...props} key={option.code} style={MenuItemStyle}>
            <Checkbox checked={checkedEntity.includes(option)} />
            <ListItemText primary={option.display} />
          </li>
        )}
        onChange={onSelectHandler}
      />
    </TableContainer>
  );
};

export default ModifiedAutocomplete;
